import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-58",
  "use": "icon-sheet_icon-58-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-58\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M3 17.333V8l9 4.667L21 8v9.333L12 22l-9-4.667zM3 8l9-4.641L21 8M7.5 10.302l8.82-4.765\" stroke-linejoin=\"round\" /><path d=\"M12 12.667V22\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol